var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/72b1ff78ed0b5345697d136ae9cca3cb.js').default;export default
        Object.assign({}, scope_0 )
    